import React, { useEffect, useState, useCallback } from "react";
import Approved from "../Approved";
import Verified from "../Verified";
import SendButton from "../SendButton";
import Table from "../Table";
import { Button } from "semantic-ui-react";

const SubitemTable = (props) => {
  const [header, setHeader] = useState([
    "PEDIDO ID",
    "CURSO",
    "NOME PESSOA",
    "TOTAL",
    "CERTIFICADOS",
    "MATERIAIS",
    "DATA",
    "STATUS",
    "AÇÃO",
  ]);
  const [body, setBody] = useState([]);

  const getLineCells = useCallback(
    (subitem) => {
      const {
        nome_curso,
        pessoa,
        id_pedido,
        dataPed,
        obs,
        certificados,
        materiais,
        ambos,
        total,
        statusPagamento,
      } = subitem;

      const cellAcao = (
        <Button
          onClick={() => props.handleVirar(dataPed, id_pedido)}
          positive={statusPagamento === "Pago"}
        >
          {statusPagamento === "Pago" ? "Virado" : "Virar"}
        </Button>
      );

      const responseArray = [
        id_pedido,
        nome_curso,
        pessoa,

        total,
        certificados,
        materiais,
        dataPed,
        statusPagamento,
        cellAcao,
      ];

      return responseArray;
    },
    [props]
  );

  useEffect(() => {
    const newBody = props.subitens.map((subitem) => getLineCells(subitem));

    setBody(newBody);
  }, [props]);

  return <Table header={header} body={body} />;
};

export default SubitemTable;
